import { Component, computed, inject, input, signal } from "@angular/core"
import { RouterLink } from "@angular/router"
import { IntroLegacyCardData } from "../intro.model"
import { NgOptimizedImage } from "@angular/common"
import { StorageService } from "../../../../services/storage.service"

@Component({
  imports: [
    RouterLink,
    NgOptimizedImage,
  ],
  providers: [],
  standalone: true,
  template: `
    @if (cardData(); as data) {
      <div
        [style.margin-left.px]="data.style.marginLeft"
        class="relative cursor-pointer w-[250px]"
        role="button"
        [aria-label]="ariaLabel()"
        [routerLink]="[]"
        [fragment]="'legacy-for-today-' + data.type.current.toLowerCase()"
        queryParamsHandling="preserve"
        (mouseover)="hover.set(true)"
        (mouseout)="hover.set(false)"
      >
        <img
          [ngSrc]="imageSrc()"
          [alt]="data.image.altText"
          style="position: relative"
          [style.filter]="!hover() ? 'brightness(120%)' : ''"
          class="rounded-2xl"
          fill=""
        >
        <div class="absolute bottom-5 left-5 text-white text-2xl font-black">
          {{ data.title }}
        </div>
      </div>
    }
  `,
  selector: "e2e-legacy-card",
})
export class LegacyCardComponent {
  private storageService = inject(StorageService)

  cardData = input.required<IntroLegacyCardData>()

  imageSrc = computed(() =>
    this.storageService.getFileUrl(this.cardData()?.image.src)
  )
  hover = signal(false)

  ariaLabel = computed(() => {
    return `Title: ${this.cardData().title}. Click to view legacy for today`
  })

}
